module.exports = __webpack_public_path__ + "img/icon_4_10.3380c258.png";